module.exports = __webpack_public_path__ + "img/agent-module.8559949e.svg";